import React from 'react';
import { GetData, UploadURL } from '../../api/service';
import {
  Container,
  Typography,
  Grid,
  Paper,
  Divider,
  Box,
} from '@material-ui/core';

export default function RegistrationView({ id }) {
  const [data, setData] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    GetData(`/nss/student/${id}`).then((response) => {
      setData(response);
      setIsLoaded(true);
    });
  }, [id]);

  const section = (title) => (
    <Grid item xs={12}>
      <Typography variant="h6" style={{ fontWeight: 'bold', marginTop: 16 }}>
        {title}
      </Typography>
      <Divider />
    </Grid>
  );

  const field = (label, value) => (
    <Grid item xs={12} md={6}>
      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
        {label}:
      </Typography>
      <Typography variant="body2">{value || 'N/A'}</Typography>
    </Grid>
  );

  const fileField = (label, value) => (
    <Grid item xs={12} md={6}>
      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
        {label}:
      </Typography>
      {value ? (
        value.includes('.jpg') || value.includes('.png') ? (
          <img src={`${UploadURL}${value}`} alt={label} style={{ maxWidth: 200, maxHeight: 200 }} />
        ) : (
          <a href={`${UploadURL}${value}`} target="_blank" rel="noopener noreferrer">
            View File
          </a>
        )
      ) : (
        <Typography variant="body2">N/A</Typography>
      )}
    </Grid>
  );

  if (!isLoaded) return <Typography>Loading...</Typography>;

  return (
    <Container maxWidth="xl" style={{ padding: 16 }}>
      <Paper style={{ padding: 16 }}>
        <Typography variant="h4" align="center" gutterBottom>
          NSS Registration Details – {data.student_name}
        </Typography>

        <Grid container spacing={2}>
          {section("Academic Details")}

          {field("College Roll Number", data.roll_no)}
          {field("Samarth Form Number", data.samarth)}
          {field("Programme of Study", data.course)}
          {field("Department / Stream", data.department)}
          {field("Semester / Year", data.year_semester)}

          {section("Personal Details")}

          {field("Student Name", data.student_name)}
          {fileField("Photo", data.photo)}
          {field("Date of Birth", data.dob)}
          {field("Email ID", data.email)}
          {field("Contact Number", data.mobile)}
          {field("WhatsApp Number", data.whatsapp)}
          {field("Gender", data.gender)}

          {section("Family Details")}

          {field("Father Name", data.father_name)}
          {field("Father Contact Number", data.father_contact)}
          {field("Mother Name", data.mother_name)}
          {field("Mother Contact Number", data.mother_contact)}
          {field("Local Guardian Name", data.guardian)}
          {field("Relationship with Local Guardian", data.guardian_relation)}
          {field("Guardian Contact Number", data.guardian_contact)}

          {section("Health & Social Details")}

          {field("Blood Group", data.blood_group)}
          {field("Medical Condition", data.medical_condition)}
          {field("State of Permanent Residence", data.state)}
          {field("Family Annual Income", data.family_income)}
          {field("Permanent Address", data.address)}
          {field("Present Address", data.present_address)}
          {field("District", data.district)}
          {field("Pincode", data.pin_code)}
          {field("First Language / Community", data.first_language)}
          {field("Religion", data.religion)}
          {field("Category", data.category)}
          {fileField("Category Certificate", data.category_certificate)}
          {field("Minority", data.minority)}
          {field("BPL Category", data.bpl_category)}
          {field("EWS", data.ews)}
          {field("PwD", data.pwd)}
          {field("Disability", data.disability)}

          {section("Identity Documents & Bank Details")}

          {field("PAN Number", data.pan_number)}
          {fileField("PAN Card", data.pan_card)}
          {field("AADHAAR Number", data.aadhaar_number)}
          {fileField("AADHAAR Card", data.aadhaar_card)}
          {field("APAAR ID Number", data.apaar_id)}
          {fileField("APAAR ID", data.apaar_id_file)}
          {field("Bank Account Number", data.bank_account)}
          {field("Bank Name", data.bank_name)}
          {field("Account Holder Name", data.account_holder)}
          {field("IFSC Code", data.ifsc_code)}
          {field("Bank Branch Name", data.bank_branch)}
          {fileField("Passbook", data.passbook)}

          {section("Educational & Other Details")}

          {field("10th Percentage", data.tenth_percentage)}
          {field("12th Percentage", data.twelfth_percentage)}
          {field("12th Stream", data.twelfth_stream)}
          {field("Scholarship Details", data.scholarship_details)}
          {field("Perceived Career", data.perceived_career)}
          {field("Hobbies / Skills", data.hobbies_skills)}
          {field("Knowledge of Computer", data.computer_knowledge)}
          {field("My Bharat ID", data.bharat_id)}
          {field("Declaration Accepted", data.declaration_accepted ? 'Yes' : 'No')}
          {field("Registration Date", data.registration_date)}
        </Grid>
      </Paper>
    </Container>
  );
}
